// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminFooter-footerContainer-bJ9WY {
    position: fixed;
    bottom: 0;
    left: var(--sideMenu-width);
    right: 0;
    padding: 15px;
    text-align: center;
    background: var(--common-gray-bg-color);
    border-top: 1px solid var(--primary-border);
    z-index: 1030;
}

@media screen and (max-width: 1199px) {
    .AdminFooter-footerContainer-bJ9WY {
        width: 100%;
        left: 0;
        right: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/AdminFooter/AdminFooter.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,SAAS;IACT,2BAA2B;IAC3B,QAAQ;IACR,aAAa;IACb,kBAAkB;IAClB,uCAAuC;IACvC,2CAA2C;IAC3C,aAAa;AACjB;;AAEA;IACI;QACI,WAAW;QACX,OAAO;QACP,QAAQ;IACZ;AACJ","sourcesContent":[".footerContainer {\n    position: fixed;\n    bottom: 0;\n    left: var(--sideMenu-width);\n    right: 0;\n    padding: 15px;\n    text-align: center;\n    background: var(--common-gray-bg-color);\n    border-top: 1px solid var(--primary-border);\n    z-index: 1030;\n}\n\n@media screen and (max-width: 1199px) {\n    .footerContainer {\n        width: 100%;\n        left: 0;\n        right: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footerContainer": `AdminFooter-footerContainer-bJ9WY`
};
module.exports = ___CSS_LOADER_EXPORT___;
